'use strict'

import master from 'Modules/master'
import bootstrapValidationForm from 'Modules/bootstrapValidationForm'
import rollingTexts from 'Modules/rollingTexts'

master.process()
rollingTexts.init()

$(window).load(function () {
    $('.form-group').removeClass('has-success')
})

// Vérifie si le pays sélectionné fais partie de France DOM TOM et les iles françaises
function isCodePaysFrance(selectedPays) {
    const codePays = ['FR', 'GF', 'GP', 'MQ', 'RE', 'PF', 'PM', 'WF', 'YT']

    return codePays.includes(selectedPays)
}

const getUrlParameter = (sParam) => {
    const sPageURL = window.location.search.substring(1)
    const sURLVariables = sPageURL.split('&')
    let sParameterName
    let i

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=')

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined
                ? true
                : decodeURIComponent(sParameterName[1])
        }
    }
}

const selectedTab = getUrlParameter('selectedTab')
if (selectedTab == 'Billing') {
    $('#headingcadrliv').removeClass('active')
    $('#headingcadrliv').siblings('#collapseadrliv').removeClass('in')
    $('#headingmesinfos').addClass('active')
    $('#headingmesinfos').siblings('#collapsemesinfos').addClass('in')
} else if (selectedTab == 'Password') {
    $('#headingcadrliv').removeClass('active')
    $('#headingcadrliv').siblings('#collapseadrliv').removeClass('in')
    $('#headingchangepwd').addClass('active')
    $('#headingchangepwd').siblings('#collapsechangepwd').addClass('in')
}

$('.item-header').on('click', function () {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active')
    } else {
        $('.item').removeClass('active')
        $(this).addClass('active')
    }
})
$('.nous-contacter a').on('click', function () {
    if ($(this).hasClass('inactive')) {
        $(this).removeClass('inactive')
        $(this).addClass('active')
    } else {
        $(this).removeClass('active')
        $(this).addClass('inactive')
    }
})
$('a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    bootstrapValidationForm.validate('.formbilling', '.form-control')
    bootstrapValidationForm.validate('.formdelivery', '.form-control')
})

// Fonction d'initialisation de la fonction de modification du code postal
function InitButtons(
    isbilling,
    validateCP,
    changeVille,
    validateVille,
    clientCP,
    clientVille,
    ddlVille,
    changeCP,
    codePays,
    champsCP
) {
    const obj = {
        validateCP: validateCP,
        changeVille: changeVille,
        validateVille: validateVille,
        clientCP: clientCP,
        clientVille: clientVille,
        ddlVille: ddlVille,
        changeCP: changeCP,
        codePays: codePays,
        champsCP: champsCP
    }

    SetUpBehavior(obj)
}

function SetUpBehavior(obj) {
    obj.changeCP.click(function () {
        obj.clientCP.removeAttr('readonly')
        obj.changeCP.hide()
        obj.validateCP.show()
    })

    obj.champsCP.click(function () {
        obj.clientCP.removeAttr('readonly')
        obj.changeCP.hide()
        obj.validateCP.show()
    })

    obj.validateCP.click(function () {
        const cp = obj.clientCP.val()

        if (cp == '' || cp == undefined) {
            return
        }

        const formname = $(this).closest('form').data('classvalidator')
        bootstrapValidationForm.setItemAsValid(formname, 'model.CP', 'notEmpty')
        bootstrapValidationForm.setItemAsValid(formname, 'model.CP', 'callback')

        if (obj.codePays.val() != 'FR') {
            obj.clientVille.data('villecperror', 0)
            bootstrapValidationForm.setItemAsValid(
                formname,
                'model.Ville',
                'callback'
            )
            bootstrapValidationForm.disableValidator(
                formname,
                'model.Ville',
                'VilleCpError'
            )
            return
        } else {
            obj.clientVille.val('')
            bootstrapValidationForm.enableValidator(
                formname,
                'model.Ville',
                'VilleCpError'
            )
        }

        $.ajax({
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            type: 'GET',
            url: '/Club/GetVilles',
            data: { codePostal: cp, codePays: obj.codePays.val() },
            success: function (data) {
                obj.ddlVille.empty()

                const parsed = JSON.parse(data)

                if (parsed.length > 0) {
                    $(parsed).each(function () {
                        const valuePays = this
                        obj.ddlVille.append(
                            $('<option></option>')
                                .val(valuePays.NomVilleReel)
                                .html(valuePays.NomVille)
                        )
                    })
                    obj.ddlVille.show()
                    obj.clientVille.hide()
                    obj.validateCP.hide()
                    obj.changeVille.show()
                } else {
                    obj.clientCP.val('')
                    obj.changeVille.show()
                    obj.changeVille.click()
                }
            },
            failure: function (response) {}
        })

        obj.clientCP.attr('readonly', true)
    })

    obj.codePays.change(function () {
        ResetButtons(obj)
    })

    obj.ddlVille.change(function () {
        villeChanged(obj, $(this))
    })

    obj.changeVille.click(function () {
        villeChanged(obj, $(this))
    })

    ResetButtons(obj)
}

function villeChanged(obj, element) {
    let valueVille = ''

    if (obj.ddlVille.val() != null) {
        valueVille = obj.ddlVille.val()
    }

    obj.clientVille.val(valueVille)

    ResetButtons(obj)

    const formname = element.closest('form').data('classvalidator')
    bootstrapValidationForm.setItemAsValid(formname, 'model.Ville', 'notEmpty')
    bootstrapValidationForm.setItemAsValid(formname, 'model.Ville', 'callback')
}

function ResetButtons(obj) {
    obj.validateCP.hide()
    obj.changeVille.hide()
    obj.validateVille.hide()
    obj.clientVille.show()
    obj.ddlVille.hide()
    obj.ddlVille.empty()
    obj.changeCP.show()

    obj.validateCP.removeClass('hidden')
    obj.changeVille.removeClass('hidden')
    obj.validateVille.removeClass('hidden')
    obj.ddlVille.removeClass('hidden')

    const isfrance = isCodePaysFrance(obj.codePays.val())

    obj.clientVille.attr('readonly', isfrance)

    if (isfrance) {
        obj.changeCP.show()
    } else {
        obj.changeCP.hide()
    }

    const formId = $(obj.codePays).closest('form').data('classvalidator')

    if ($(obj.codePays).find('option:selected').val() == 'FR') {
        bootstrapValidationForm.enableValidator(
            formId,
            'model.CP',
            'stringLength'
        )
        bootstrapValidationForm.enableValidator(
            formId,
            'model.Telephone',
            'regexp'
        )
    } else {
        bootstrapValidationForm.disableValidator(
            formId,
            'model.CP',
            'stringLength'
        )
        bootstrapValidationForm.disableValidator(
            formId,
            'model.Telephone',
            'regexp'
        )
    }

    bootstrapValidationForm.validate(formId, '.form-control')
}

// Mise en place de la configuration
InitButtons(
    true,
    $('#validateCP'),
    $('#changeVille'),
    $('#validateVille'),
    $('#clientCP'),
    $('#clientVille'),
    $('#ddlVille'),
    $('#changeCP'),
    $('#codePays'),
    $('#clientCP')
)
InitButtons(
    true,
    $('#validateCPDelivery'),
    $('#changeVilleDelivery'),
    $('#validateVilleDelivery'),
    $('#clientCPDelivery'),
    $('#clientVilleDelivery'),
    $('#ddlVilleDelivery'),
    $('#changeCPDelivery'),
    $('#codePaysDelivery'),
    $('#clientCPDelivery')
)

function InitAdresseForm(formclass) {
    bootstrapValidationForm.initForm(
        formclass,
        function init(event) {},
        function removeTelephoneIcon(e, data) {}
    )

    bootstrapValidationForm.enableValidator(
        formclass,
        'model.CP',
        'VilleCpError'
    )
    bootstrapValidationForm.enableValidator(
        formclass,
        'model.Ville',
        'VilleCpError'
    )

    // Vérification de tous les champs du formulaire au chargement
    bootstrapValidationForm.validate(formclass, '.form-control')

    if ($(formclass).data('adressevalide') == 'False') {
        bootstrapValidationForm.setItemAsInvalid(
            formclass,
            'model.Ville',
            'VilleCpError'
        )
        bootstrapValidationForm.setItemAsInvalid(
            formclass,
            'model.CP',
            'VilleCpError'
        )
    }

    if ($(formclass).find("select[name='model.CodePays']").val() != 'FR') {
        bootstrapValidationForm.disableValidator(
            formclass,
            'model.Telephone',
            'regexp'
        )
        bootstrapValidationForm.setItemAsValid(
            formclass,
            'model.Telephone',
            'regexp'
        )
    }
}

InitAdresseForm('.formbilling')
InitAdresseForm('.formdelivery')

$('#fileInput').change(function () {
    if (this.files.length > 0) {
        if (this.files[0].size > 1000000) {
            $('#fileInputInfo').show()
            $(this).val(null)
        } else {
            $('#fileInputInfo').hide()
        }
        const fileName = $(this).val()
        const extFile = fileName.split('.').pop()
        if (
            extFile != 'jpg' &&
            extFile != 'jpeg' &&
            extFile != 'png' &&
            extFile != 'pdf' &&
            extFile != 'JPG' &&
            extFile != 'JPEG' &&
            extFile != 'PNG'
        ) {
            $('#fileInputInfoType').show()
            $(this).val(null)
        } else {
            const namedocument =
                document.querySelector('input[type=file]').files[0].name
            $('.statusfile').html(namedocument)
            $('#fileInputInfoType').hide()
        }
    }
})

//on envoie le formulaire
var formSendMessageClient = document.getElementById('FormSendMessageClient')
var btnContactForm = document.getElementById('btnContactForm')

if (formSendMessageClient) {
    formSendMessageClient.addEventListener('submit', function (event) {
        event.preventDefault()
        btnContactForm.disabled = true

        var url = formSendMessageClient.getAttribute('action')
        var formData = new FormData(formSendMessageClient)

        const requestOptions = {
            method: 'POST',
            body: formData
        }

        fetch(url, requestOptions)
            .then((r) => {
                alert('Votre message est envoyé')
                window.location.href = '?isSuivi=true#collapsesuivimessage'
            })
            .catch((e) => {
                alert('Une erreur est survenue')
            })
            .finally(() => {
                btnContactForm.disabled = false
            })
    })
}

/**
 * CHANGER MOT DE PASSE
 */
$('.frmPassword').on('submit', function () {
    let result = false
    $('.lblMessage').html('')

    const viewModel = {
        NewPassword: $('[name="viewModel.NewPassword"]').val(),
        NewPassword2: $('[name="viewModel.NewPassword2"]').val(),
        PreviousPassword: $('[name="viewModel.PreviousPassword"]').val()
    }

    $.ajax({
        contentType: 'application/json; charset=utf-8',
        dataType: 'html',
        type: 'POST',
        async: false,
        url: '/Club/CheckPassword',
        data: JSON.stringify(viewModel),
        success: function (data) {
            const parsed = JSON.parse(data)

            if (parsed.Result) {
                result = true
            } else {
                $('.lblMessage').html(parsed.Message)
            }
        },
        failure: function () {}
    })

    return result
})
